(() => {
 function init() {
 const card=document.querySelector('#photo-category');
 const grid=document.querySelector('[data-craft-section="main-product"] .oc-style-grid');
 if(!card||!grid||document.querySelector('[data-photo-category]'))return;
 let filters=document.querySelector('.oc-design-filters');
 if(!filters){filters=document.createElement('div');filters.className='oc-design-filters';const all=document.createElement('button');all.type='button';all.textContent=card.dataset.allLabel;all.setAttribute('aria-pressed','true');all.dataset.photoAll='';filters.append(all);grid.before(filters);}
 const button=document.createElement('button');button.type='button';button.textContent=card.dataset.categoryLabel;button.dataset.photoCategory='';button.setAttribute('aria-pressed','false');button.setAttribute('aria-controls',card.id);filters.append(button);
 card.classList.add('oc-photo-category-card');grid.after(card);
 const normal=[...filters.querySelectorAll('button:not([data-photo-category])')];
 button.addEventListener('click',()=>{normal.forEach(b=>b.setAttribute('aria-pressed','false'));button.setAttribute('aria-pressed','true');grid.classList.add('oc-photo-grid-hidden');card.hidden=false;});
 normal.forEach(b=>b.addEventListener('click',()=>{button.setAttribute('aria-pressed','false');grid.classList.remove('oc-photo-grid-hidden');card.hidden=true;if(b.hasAttribute('data-photo-all'))b.setAttribute('aria-pressed','true');}));
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

(() => {
  let pending = false;
  const update = () => {
    pending = false;
    const active = window.matchMedia('(max-width: 749px)').matches && [...document.querySelectorAll('#photo-category, #photo-personal, #photo-collection')].some(card => {
      const r = card.getBoundingClientRect();
      return !card.hidden && r.height > 0 && r.bottom > 82 && r.top < window.innerHeight;
    });
    document.querySelector('#oc-chat-launcher')?.classList.toggle('oc-photo-float-paused', active);
    document.querySelectorAll('shopify-forms-embed').forEach(host => {
      const teaser = host.shadowRoot?.querySelector('[data-current-step="tease"]');
      host.classList.toggle('oc-photo-float-paused', active && !!teaser);
    });
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('click', schedule);
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  schedule();
})();
